import {Component, OnInit} from '@angular/core';
import {TipoCredencial} from '../../../enums/tipo-credencial-enum';
import {MensagensService} from 'max-ng-lib';
import {RastreadorService} from '../../../../../services/rastreador.service';
import {Observable} from 'rxjs';

@Component({
	selector: 'm-configuracao-rastreadores',
	templateUrl: './configuracao-rastreadores.component.html',
	styleUrls: ['./configuracao-rastreadores.component.scss']
})

export class ConfiguracaoRastreadoresComponent implements OnInit {

	tipoCredencial = TipoCredencial;

	rastreadores = [
		{
			name: 'ZUQ',
			descricao: 'ZUQ',
			tipoCredencial: TipoCredencial.TOKEN
		},
		{
			name: 'VELOTRACK',
			descricao: 'VELOTRACK',
			tipoCredencial: TipoCredencial.LOGIN
		}];

	selectedOption: { name: string, descricao: string, tipoCredencial: TipoCredencial };
	rastreadorHabilitado: boolean = false;
	login: string;
	senha: string;
	token: string;
	mostrarSenha: boolean = false;

	rastreadoresSalvos: { ativo; boolean, login: string, senha: string, token: string, identificador: string, id: number }[] = [];

	constructor(private mensagensService: MensagensService,
				private rastradorService: RastreadorService) {
	}

	ngOnInit() {
		this.listarRastradores();
	}

	salvar() {

		this.validarCredenciais().subscribe((value) => {
			if (value === true) {

				const rastreadorSalvo = this.getRastreadorSalvo();

				const dadosParaSalvar = {
					identificador: this.selectedOption.name,
					ativo: this.rastreadorHabilitado,
					login: this.selectedOption.tipoCredencial === this.tipoCredencial.LOGIN ? this.login : '',
					senha: this.selectedOption.tipoCredencial === this.tipoCredencial.LOGIN ? this.senha : '',
					token: this.selectedOption.tipoCredencial === this.tipoCredencial.TOKEN ? this.token : '',
					id: rastreadorSalvo != null ? rastreadorSalvo.id : null
				};

				this.rastradorService.salvar(dadosParaSalvar).subscribe(() => {
					this.mensagensService.exibaToastSucesso('Rastreador salvo com sucesso!');
					this.listarRastradores();
				}, error => {
					console.error(error);
					this.mensagensService.exibaToastAlerta('Erro ao salvar rastreador!');
				});
			}
		});
	}

	listarRastradores() {
		this.rastradorService.listarTodos().subscribe((rastreadores) => {
			this.rastreadoresSalvos = rastreadores;
		});
	}

	private getRastreadorSalvo() {
		return this.rastreadoresSalvos.find(r => r.identificador === this.selectedOption.name);
	}

	verificarEstadoSelect() {
		if (this.selectedOption != null && this.rastreadoresSalvos.length > 0) {

			const value = this.getRastreadorSalvo();

			if (value) {
				this.rastreadorHabilitado = value.ativo;
				this.login = value.login;
				this.senha = value.senha;
				this.token = value.token;
			} else {
				this.rastreadorHabilitado = false;
				this.login = '';
				this.senha = '';
				this.token = '';
			}
		}
	}

	verificarDados(): boolean {

		const {tipoCredencial} = this.selectedOption;

		if (this.rastreadorHabilitado && tipoCredencial === TipoCredencial.TOKEN && (!this.token || !this.token.length)) {
			this.mensagensService.exibaToastAlerta('Por Obséquio Informe o Token!!');
			return false;
		}

		if (this.rastreadorHabilitado && tipoCredencial === TipoCredencial.LOGIN) {
			if (!this.login || !this.login.length) {
				this.mensagensService.exibaToastAlerta('Por Obséquio Informe o Login!!');
				return false;
			}
			if (!this.senha || !this.senha.length) {
				this.mensagensService.exibaToastAlerta('Por Obséquio Informe a senha!!');
				return false;
			}
		}

		return true;
	}

	validarCredenciais() {

		return new Observable((observer) => {

			if (!this.rastreadorHabilitado) {
				return observer.next(true);
			}

			this.mensagensService.exibaToastAlerta('Validando Credenciais!');

			const dadosParaValidar = {
				identificador: this.selectedOption.name,
				login: this.selectedOption.tipoCredencial === this.tipoCredencial.LOGIN ? this.login : '',
				senha: this.selectedOption.tipoCredencial === this.tipoCredencial.LOGIN ? this.senha : '',
				token: this.selectedOption.tipoCredencial === this.tipoCredencial.TOKEN ? this.token : '',
			};

			this.rastradorService.validarCredenciais(dadosParaValidar).subscribe((res) => {
				this.mensagensService.exibaToastSucesso('Credenciais Válidas!');
				return observer.next(res);
			}, (value) => {
				this.mensagensService.exibaToastAlerta('Credenciais Inválidas!');
				console.error(value);
				return observer.next(false);
			});
		});
	}

}
